<template>
  <div class="color-pallet-container">
    <b-form-radio-group v-model="internalValue" class="color-pallet-group" @input="onChange">
      <template>
        <b-form-radio
          v-for="option in options"
          :key="option.value"
          :disabled="option.disabled"
          class="color-pallet-item"
          :class="option.value ? `color-pallet-item-${option.value}` : 'color-pallet-item-empty'"
          :value="option.value"
        ></b-form-radio>
      </template>
    </b-form-radio-group>
  </div>
</template>

<script>
export default {
  name: 'ColorPalletRadio',
  props: {
    value: { required: true, type: String },
    colors: { required: true, type: Object },
    emptyItem: { type: Boolean },
    disabledColorKeys: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      colorValue: '',
    };
  },
  computed: {
    internalValue: {
      get() {
        if (this.colorValue) {
          return this.colorValue;
        }
        return this.value;
      },
      set(v) {
        this.colorValue = v;
      },
    },
    options() {
      let options = [];

      if (this.emptyItem) {
        options.push({ text: '', value: null, disabled: false });
      }

      for (const key in this.colors) {
        let option = { text: '', value: key, disabled: false };
        if (this.disabledColorKeys.indexOf(key) != -1) {
          option.disabled = true;
        }
        options.push(option);
      }
      return options;
    },
  },
  methods: {
    onChange() {
      this.$emit('input', this.internalValue);
    },
  },
};
</script>
